<div class="info-tool d-flex flex-column position-relative">
  <img src="../../../assets/icons/admi_01.svg" width="12px" alt="">
  <span class="tooltip-info shadow-md">
    <table class="table-info-tool">
      <tr style="border-bottom: 1px solid #ececec;">
        <th style="text-align: center">
          <div class="d-flex align-items-center justify-content-center" style="min-height: 45px;">
            <p class="mb-0" style="text-transform: capitalize;">Cambio</p>
          </div>
        </th>
      </tr>
      <ng-container *ngFor="let currency of currencies; let i = index">
        <tr *ngIf="currency.code !== currencyAgency?.code" >
         <td class="d-flex justify-content-center align-items-center" style="height: 38px;">
          <p class="mb-0" >
            <span style="color: #656565; font-weight: 400;"> {{ currency.code }}</span>
            <span style="font-weight: 600; color: #666666;">&nbsp;{{
                                valueProduct
                              | currencyConverter:
                                    currencyProduct:
                                    currencyAgency?.code:
                                    currencies
                              | currencyConverter:
                                    currencyAgency?.code:
                                    currency.code:
                                    currencies
                              | number: '1.2-2'
                            }}
              </span>
            </p>
          </td>
        </tr>
      </ng-container>
    </table>
  </span>
</div>
